import PlaylistWithStyle from './playlist-with-style'

export default PlaylistWithStyle
